import { Component } from '@angular/core';
import { BaseIndexPageComponent } from 'src/app/components/pages/base-index-page/base-index-page.component';
import BaseIndexPageConfig from 'src/app/components/pages/base-index-page/base-index-page.config';
import { DataTableColumnActions } from 'src/app/components/widgets/data-table/columns/data-table-column-actions/data-table-column-actions.config';
import { DataTableColumnText } from 'src/app/components/widgets/data-table/columns/data-table-column-text/data-table-column-text.config';
import ApiOptionsConfig from 'src/app/services/api/api-options.config';
import { ProjectsService } from 'src/app/services/api/projects.service';
import { RouteService } from 'src/app/services/route.service';

@Component({
  selector: 'app-projects-checklist-index-page',
  imports: [BaseIndexPageComponent],
  templateUrl: './projects-checklist-index-page.component.html',
  styleUrl: './projects-checklist-index-page.component.scss'
})
export class ProjectsChecklistIndexPageComponent {
 list: any[] = [];

  baseIndexPageConfig: BaseIndexPageConfig;

  constructor(
    protected projectsService: ProjectsService,
    private routeService: RouteService
  ) {
    this.baseIndexPageConfig = {
      pageTitle: 'Checklist',
      cardTitle: 'Manage Checklist',
      addNewItemButton: {
        type: 'success',
        title: 'Add Checklist',
        onClick: () => {
          this.routeService.projectsSettingsChecklistCreate()
        }
      },
      dataTable: {
        data: [],
        searchModel: {
          userId: null,
          firstName: null,
          lastName: null,
        },
        pagination: null,
        columns: [
          new DataTableColumnText({
            attribute: 'Jurisdiction',
            header: 'Jurisdiction',
            filter: 'select',            
            filterOptionsSource: 'jurisdaction',
            value: (item: any) => {
              return item.jurisdiction.name;
            }
          }),
          new DataTableColumnText({
            attribute: 'Name',
            header: 'Name',
            filter: 'text',
            value: (item: any) => {
              return item.name;
            }
          }),
          new DataTableColumnText({
            attribute: 'Details',
            header: 'Details',
            filter: 'text',
            value: (item: any) => {
              return item.details;
            }
          }),
          new DataTableColumnActions({
            header: 'Actions',
            attribute: 'actions',
            style: { width: '50px' },
            buttons: [
              {
                icon: 'fa-eye',
                tooltip: 'View chechlist details',
                onClick: (item: any) => {
                  this.routeService.projectsSettingsChecklistDetail(item.checklistId)
                }
              },
              {
                icon: 'fa-edit',
                tooltip: 'Edit chechlist',
                onClick: (item: any) => {
                  this.routeService.projectsSettingsChecklistUpdate(item.checklistId)
                }
              },
              {
                icon: 'fa-trash',
                tooltip: 'Delete category',
                onClick: (item: any) => {
                },
                isDelete: true
              },

            ]
          })
        ]
      },
      apiListService: (options: ApiOptionsConfig) => this.projectsService.listSettingsChecklist(options),
      responseListModelName: 'checklists',
    }
  }
}
